import React from 'react'

/** When true (during flipbook page/sub-slide transition), skip viewport-triggered entrances */
export const FlipViewportAnimationSuppressContext = React.createContext(false)
